import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import { useOptimizelyUserDecisions } from '../optimizely-for-client'
import { getCurrentPublicRuntimeConfig } from '../../../utils/helpers/helpers'
import { OPTIMIZELY_FLAGS_ENUM } from '../../../constants'
import { PlacesSearchConfigType } from 'src/components/SearchForm/SearchForm.types'

export const useOptimizelyPlacesJson = (
  brand: Brand,
  locale: string,
  placesSearchConfig: PlacesSearchConfigType,
): PlacesSearchConfigType => {
  const publicRuntimeConfig = getCurrentPublicRuntimeConfig()
  const decisions = useOptimizelyUserDecisions()
  const optimizelyData =
    decisions?.[OPTIMIZELY_FLAGS_ENUM.AGE_MFE_ACTIVATE_PLACES_API]
  const optimizelyVariableKey =
    publicRuntimeConfig?.features?.placesApiOptimizelyVariableKey

  const optimizelyPlacesData =
    optimizelyData?.variables?.[optimizelyVariableKey]

  // Is Places-XP- & Enable-On-Landing-MFE -flag enabled in Optimizely
  if (optimizelyData?.enabled && optimizelyPlacesData?.['enableOnLandingMfe']) {
    placesSearchConfig.useLegacyDestinationSelector =
      !!optimizelyPlacesData?.[brand]?.useLegacyDestinationSelector

    placesSearchConfig.initialParentDestinationList =
      optimizelyPlacesData?.[brand]?.initialParentDestinationList
        ?.filter((optimizelyObject) => optimizelyObject.locale === locale)
        .map((initParent) => initParent.placesApiId)
        .join() || null

    placesSearchConfig.googleFallbackMethod =
      optimizelyPlacesData?.[brand]?.googleFallbackMethod?.[locale] ||
      placesSearchConfig.googleFallbackMethod

    placesSearchConfig.pageSize = optimizelyPlacesData?.['pageSize']
    placesSearchConfig.pageSizePopular =
      optimizelyPlacesData?.['pageSizePopular']
  }

  return placesSearchConfig
}
